import { render, staticRenderFns } from "./migrationdendaharian.vue?vue&type=template&id=184d9806&scoped=true&"
import script from "./migrationdendaharian.vue?vue&type=script&lang=js&"
export * from "./migrationdendaharian.vue?vue&type=script&lang=js&"
import style0 from "./migrationdendaharian.vue?vue&type=style&index=0&id=184d9806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184d9806",
  null
  
)

export default component.exports